import { Chip, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'

import { CollectionStatus, Maybe } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type ConsoleStatusCellProps = {
  status?: Maybe<CollectionStatus>
}

export const CollectionStatusCell: Cell<ConsoleStatusCellProps> = ({
  status,
}) => {
  const { t } = useTranslation('consoleEvents')
  const { label, sx } = useMemo(() => {
    if (status === CollectionStatus.Archived) {
      return {
        label: t(CollectionStatus.Archived),
        sx: { bgcolor: 'text.disabled' },
      }
    }
    if (status === CollectionStatus.Published) {
      return {
        label: t(CollectionStatus.Published),
        sx: { bgcolor: 'primary.main' },
      }
    }
    return {
      label: t(CollectionStatus.Unpublished),
      sx: { bgcolor: 'text.disabled' },
    }
  }, [status, t])

  return (
    <CellFrame sx={{ pb: 2 }}>
      <Stack direction="row" spacing={2}>
        <Chip
          label={
            <Typography variant="overline" color="white">
              {label}
            </Typography>
          }
          sx={{
            ...sx,
            p: 1,
            height: 20,
            '.MuiChip-label': { px: 0 },
          }}
        />
      </Stack>
    </CellFrame>
  )
}
